import EventBus from '@/bus'

if (!window.__POWERED_BY_QIANKUN__) {
  window.middleCallback = (page, res) => {
    EventBus.$emit('middleCallback:' + page, res)
  }

  window.addEventListener('message', (event) => {
    if (event.origin == null) {
      return
    }

    // Make sure the data is coming from facebook.com
    if (!event.origin.endsWith('facebook.com')) {
      return
    }

    try {
      const data = JSON.parse(event.data)
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        // if user finishes the Embedded Signup flow
        if (data.event === 'FINISH') {
          const { phone_number_id, waba_id } = data.data

          EventBus.$emit('middleCallback:' + 'YCloud', { phone_number_id, waba_id })
        } else if (data.event === 'ERROR') {
          const { error_message } = data.data
          console.error('error ', error_message)
        } else {
          const { current_step } = data.data
          console.warn('Cancel at ', current_step)
        }
      }
    } catch (error) {
      console.log('Non JSON Response', event.data)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/global.js